import React from 'react';
import placeHolderImage from '../../../assets/img/default-image.svg';

const PlaceHolderImage: React.FC = () => {
    return (
        <div className="bg-off-white min-w-50px w-50px h-50px rounded-circle">
            <img src={placeHolderImage} alt="Placeholder" width={"50px"} height={"50px"} className='img-responsive rounded-circle object-fit-cover'/>
        </div>
    );
};

export default PlaceHolderImage;